import { useRouter } from "next/router";
import { useMemo } from "react";

export const useRouterDefinedParams = () => {
  const router = useRouter();
  const {
    redirect: redirectParam,
    noCode: noCodeParam,
    redirectUrl: redirectUrlParam,
  } = router.query;

  return useMemo(
    () => ({
      redirectParam,
      noCodeParam,
      redirectUrlParam,
    }),
    [router.query]
  );
};
